<template>
  <v-dialog
    v-if="selected"
    :value="dialog"
    :hide-overlay="!dialog"
    @click:outside.stop="closeDialog(true)"
    @keydown.esc="closeDialog(true)"
    persistent
    max-width="700px"
    :fullscreen="is_mobile"
    :scrollable="is_mobile"
    overlay-opacity="50"
    content-class="default-dialog"
    >
    <v-card class="default-dialog-card">
      <v-card-title class="dialog-title">
        <span class="headline">
          <v-icon class="toolbar-icon">{{ (id > 0 ? 'mdi-playlist-edit' : 'mdi-playlist-plus') }}</v-icon>
          {{ (id > 0 ? `${lang.additional.edit.title} (${lang[catalog].title}) #${id}` : `${lang.additional.new.title} (${lang[catalog].title})`) }}
        </span>
        <v-spacer></v-spacer>
        <v-icon class="dialog-close-btn" @click="closeDialog(true)">mdi-close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-container class="pa-0">
          <v-row>
            <v-col cols="12" class="additional-form pa-0">
              <v-form
                ref="SaveForm"
                v-model="valid"
                lazy-validation
                :disabled="get_interface.loading"
              >
                <v-row class="additional-form-row">
                  <v-col cols="3">
                    <v-text-field
                      :label="lang.additional.datatable.headers.code"
                      v-model="code"
                      :loading="get_interface.loading"
                      :disabled="get_interface.loading"
                      autocomplete="new-password"
                      filled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      :label="lang.additional.datatable.headers.title"
                      v-model="selected.title"
                      :rules="lang.additional.new.rules.titleRules"
                      :loading="get_interface.loading"
                      :disabled="get_interface.loading"
                      autocomplete="new-password"
                      filled
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="additional-form-row">
                  <v-col cols="7">
                    <treeselect
                      :options="categories"
                      v-model="selected.cat"
                      :placeholder="lang.additional.new.category"
                      :noChildrenText="lang.additional.new.noChildrenText"
                      :noOptionsText="lang.additional.new.noCategoriesText"
                      :noResultsText="lang.additional.new.noResultsText"
                      :clearable="false"
                      :default-expand-level="1"
                      :required="true"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-currency-field
                      :label="lang.additional.datatable.headers.price"
                      v-model="selected.price"
                      :loading="get_interface.loading"
                      :disabled="get_interface.loading"
                      filled
                    ></v-currency-field>
                  </v-col>
                  <v-col cols="1">
                    <v-switch
                      v-model="selected.active"
                      :loading="get_interface.loading"
                      :disabled="get_interface.loading"
                      class="active-switch"
                      inset
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="px-2">
                    <v-textarea
                      :label="lang.additional.datatable.headers.description"
                      v-model="selected.description"
                      :loading="get_interface.loading"
                      :disabled="get_interface.loading"
                      autocomplete="new-password"
                      filled
                      auto-grow
                      clearable
                      clear-icon="mdi-broom"
                      counter="470"
                      :rows="7"
                      class="editField"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="gray" text @click="closeDialog(true)">{{ lang.additional.new.close }}</v-btn>
        <v-btn
          color="green darken-1"
          text
          @click="saveAdditional(selected)"
          :loading="get_interface.loading"
          :disabled="get_interface.loading"
        >
          {{ lang.additional.actions.save }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import appdata from '@/mixins/appdata'
import save from '@/mixins/defaults/save'
import utils from '@/mixins/utils'
import additional from './mixins/index'

export default {
  components: { Treeselect },
  mixins: [ appdata, save, utils, additional ],
  props: {
    catalog: {
      type: String,
      required: true
    }
  },
  data: () => ({
    valid: false
  }),
  computed: {
    categories: function () {
      const noCategory = [
        {
          id: 0,
          name: this.lang.categories.new.no_cat,
          parent: 0
        }
      ]
      var additionalCat = Object.values(this.get_data.categories) || []
      additionalCat = additionalCat.filter(cat => cat.catalog === this.catalog) || []
      additionalCat = noCategory.concat(additionalCat)
      var parents = additionalCat.filter(parent => parent.parent === 0) || []
      parents.forEach(function (val) {
        const childrens = additionalCat.filter(children => children.parent !== 0 && children.parent === val.id) || []
        childrens.forEach(function (childVal) {
          childVal.label = childVal.name
        })
        val.label = val.name
        val.children = (childrens.length > 0 ? childrens : [])
      })
      return parents
    },
    code: {
      get () {
        return (typeof this.selected !== 'undefined' && typeof this.selected.cod !== 'undefined' ? this.selected.cod.trim() : '')
      },
      set (val) {
        if (val) {
          this.selected.cod = val.trim()
        }
      }
    }
  }
}
</script>

<style scoped src="./styles/save.scss" lang="scss"></style>
